import { Adapter } from "@netent/playui-origin-adapter";

const WATERMARK = Platform.isDesktopDevice ? "BLOODSUCKERS \u2122" : "BLOODSUCKERS TOUCH \u2122";

export const initAdapter = (settings) => {
    const adapter = new Adapter(window.Services, {
        gameName: WATERMARK,
        gameProducer: "NetEnt",
        containers: {
            keypad: document.querySelector(".play-ui"),
            dialog: document.querySelector(".playui-dialog")
        },
        settings: settings
    });

    return adapter;

};
